module.exports = __webpack_public_path__ + "img/img_bg.85b7eb66.png";